var queue= [];

function add(fun) {
    queue.push(fun);
    console.log("addReSize length = " + queue.length);
}

function remove(fun) {
    for (let i = 0, len = queue.length; i < len; i++) {
        if (queue[i] == fun) {
            queue.splice(i, 1);
        }
    }
    console.log("removeReSize length = " + queue.length);
}

function onReSize() {
    console.log("onReSize length = " + queue.length);
    for (let i = 0, len = queue.length; i < len; i++) {
        try {
            queue[i]();
        } catch (e) {

        }
    }
}

export default {
    onReSize, add, remove
}


// WEBPACK FOOTER //
// ./src/utils/resizemgr.js